export class Consts {
    static readonly IMATCH_ID_VALUE = "438A51D3-6864-49D7-A655-CA1153B86965";
    static readonly IMATCH_ID_NAME = "___id";
    static readonly IMATCH_MATCHES_NAME = "___matches";

    static readonly IPROXY_ID_VALUE = "BCDF5CE5-F0DF-40B7-8BA0-69DF395033C8";
    static readonly IPROXY_ID_NAME = "___id";
}